import React from "react";

import { DataTable } from "components/DataTable";
import DownloadExcelButton from "pages/LocationInsights/components/DownloadExcelButton";

import { columns } from "./column";


const ExternalViewTable = ({ data }) => {
  return <div className="flex flex-col gap-6 w-full">
    <div className="flex items-center gap-6">
      <p className="text-xl font-extrabold mr-auto">Details at glance</p>
      <DownloadExcelButton data={data} columns={columns} title="External View Summary"/>
    </div>
    <DataTable data={data} groups={columns} />
  </div>;
};

export default ExternalViewTable;
